import { formatHHMM } from '@/modules/common/time';
import { formatBedCounts, hasArea } from '@/modules/common/room-spec';
import { useRouter } from 'next/navigation';
import React from 'react';

interface RoomItem {
  id: string | number;
  isReservationAvailability?: boolean;
  imageUrl?: string;
  name?: string;
  discountPrice?: number;
  roomRate?: number;
  description?: string;
  standardPeopleCount?: number;
  maximumPersonnelCount?: number;
  squareMeter?: number;
  bedSingleSizeCount?: number;
  bedQueenSizeCount?: number;
  bedKingSizeCount?: number;
  checkIn?: string;
  checkOut?: string;
  blockTitle?: string;
}

interface RoomPeriod {
  start: string | null;
  end: string | null;
}

interface RoomHeadcount {
  adult: number | string;
  kid: number;
  pet: number;
}

interface Props {
  roomId: string;
  room: RoomItem;
  stayCount: number;
  period: RoomPeriod;
  headcount: RoomHeadcount;
}

const RoomtypeItemBox = ({ roomId, room, stayCount, period, headcount }: Props) => {
  const router = useRouter();
  const diffDate = stayCount;
  const bedText = formatBedCounts([
    ['싱글', room?.bedSingleSizeCount],
    ['퀸', room?.bedQueenSizeCount],
    ['킹', room?.bedKingSizeCount],
  ]);

  return (
    <>
      <div
        className='inline-flex flex-col cursor-pointer w-full px-10 relative'
        onClick={() =>
          room?.isReservationAvailability &&
          router.push(
            '/room/' +
              roomId +
              '?header-period=' +
              JSON.stringify(period) +
              '&header-headcount=' +
              JSON.stringify(headcount),
          )
        }
      >
        <div className="w-full flex justify-center mb-[24px]">
          <img
            className='w-full max-w-[100%] aspect-[3/2] object-fill'
            src={room?.imageUrl || '/images/stay-default-image.svg'}
            alt={room?.name || '객실 이미지'}
          />
        </div>
        <div className='flex justify-between mb-[16px] px-[10px] w-full '>
          <div className='text-[20px] font-500 mobile:text-[16px] overflow-hidden text-ellipsis pr-4 max-w-[60%]'>{room?.name}</div>
          <div className="text-right">
            <div
              className={`flex items-end justify-end ${
                room?.discountPrice
                  ? 'text-[14px] text-[#929292] line-through font-[400] mobile:text-[14px]'
                  : 'text-[20px] font-[500] mobile:text-[16px]'
              }`}
            >
              ₩{room?.roomRate?.toLocaleString()}
              <div className={`${room?.discountPrice ? 'text-[14px]' : 'text-[16px] font-[400]'} ml-1`}>
                /{diffDate}박
              </div>
            </div>
            {room?.discountPrice && (
              <div className='text-right text-[20px] mobile:text-[16px]'>
                ₩{room?.discountPrice?.toLocaleString()} /{diffDate}박
              </div>
            )}
          </div>
        </div>
        <div className='flex flex-col mb-[20px] px-[10px] w-full'>
          <div className='my-[12px] text-[14px] font-400 line-clamp-2 overflow-ellipsis'>{room?.description}</div>
          <div className='text-[16px] font-400 mobile:text-[12px]'>
            <div className="text-ellipsis overflow-hidden mb-1">
              기준 {room?.standardPeopleCount}인 (최대 {room?.maximumPersonnelCount}인)
              {hasArea(room?.squareMeter) && ` /${room?.squareMeter}㎡`}
            </div>
            {bedText && <div className="text-ellipsis overflow-hidden mb-1">침대({bedText})</div>}
            <div className="text-ellipsis overflow-hidden mb-1">
              체크인 {formatHHMM(room?.checkIn)} - 체크아웃 {formatHHMM(room?.checkOut)}
            </div>
          </div>
        </div>
        <div className="absolute bottom-0 left-0 w-full px-[40px] pb-[20px] ">
          <div className='flex justify-end w-full'>
            <div className='text-[16px] px-[14px] py-[7px] bg-[#000000] text-[#ffffff] font-600 border border-[#000000] rounded-[25px] mobile:text-[12px] whitespace-nowrap'>
              예약하기
            </div>
          </div>
        </div>
      </div>
      {room?.isReservationAvailability == false && (
        <div
          className={
            'absolute top-0 text-center flex justify-center items-center h-full w-full bg-[#6767678f]'
          }
        >
          <div className='text-center text-[20px] font-Pretendard py-4 w-full flex items-center justify-center flex-col rounded-2xl text-white'>
            <p className='mobile:text-[16px]'>{room?.blockTitle}</p>
          </div>
        </div>
      )}
    </>
  );
};

export default RoomtypeItemBox;